import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var LongTextIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M4,8.07H20a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H4a1,1,0,0,0-1,1H3A1,1,0,0,0,4,8.07Zm0,10H15a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H4a1,1,0,0,0-1,1H3A1,1,0,0,0,4,18.07Zm-1-6H3a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H4A1,1,0,0,0,3,12.07Z"
}), 'LongTextIcon');